import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Col, Nav, NavItem, NavLink, Row, TabContent, TabPane, Container } from 'reactstrap';
import Template from '../../Templates/Home';
import Title from '../../PolicyDetails/Title';
import ClaimMessage from '../ClaimMessage';
import StepOne from './StepOne';
import StepTwo from './StepTwo';

const EditClaim = ({
  defaultData,
  onConfirm,
  onContinue,
  policyData,
  bankList,
  currencyList,
  countryList,
  addBankAccount,
  active,
  setActive,
  onFileSelected,
  onFileRemoved,
  deleteBank,
  loading,
  bankSelected,
  btnClick,
  success,
  memsSuccess,
  ucrn,
  draft,
  // message,
  mandatoryFilesUploaded,
  bankDeleteLoading,
}) => {
  const breadcrumb = [
    { label: 'Dashboard', to: '/home' },
    { label: 'Policy Details', to: '/home/policyDetails' },
    { label: 'Claims', to: '/claims' },
    { label: 'Edit Claim', active: true },
  ];

  return (
    <Template pageTitle="Edit Claim" breadcrumb={breadcrumb}>
      <>
        <Container fluid className="max-container">
          <Title
            policyNumber={policyData?.policyNumber}
            certificateNumber={policyData?.certificateNumber}
            expiryDate={policyData?.expiryDate}
          />
        </Container>
        <section color="light" className="policy-details-content metLife-gray">
          <div className="container-fluid max-container">
            {!success ? (
              <Row>
                <Col className="">
                  <div className="card policy-details-tab">
                    <Nav className="w-100" tabs>
                      <NavItem>
                        <NavLink
                          className={active === '1' ? 'active' : ''}
                          onClick={() => {
                            setActive('1');
                          }}
                        >
                          Validate Personal Details
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={active === '2' ? 'active' : ''}
                          onClick={() => {
                            setActive('2');
                          }}
                        >
                          Submit Claim details
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={active} className="py-4 w-100">
                      <TabPane tabId="1">
                        <StepOne
                          policyData={policyData}
                          defaultData={defaultData}
                          onConfirm={onConfirm}
                          onContinue={onContinue}
                          bankList={bankList}
                          currencyList={currencyList}
                          countryList={countryList}
                          addBankAccount={addBankAccount}
                          deleteBank={deleteBank}
                          loading={loading}
                          bankSelected={bankSelected}
                          bankDeleteLoading={bankDeleteLoading}
                        />
                      </TabPane>
                      <TabPane tabId="2">
                        <StepTwo
                          loading={loading}
                          policyData={policyData}
                          defaultData={defaultData}
                          onConfirm={onConfirm}
                          currencyList={currencyList}
                          countryList={countryList}
                          onFileSelected={onFileSelected}
                          onFileRemoved={onFileRemoved}
                          btnClick={btnClick}
                          mandatoryFilesUploaded={mandatoryFilesUploaded}
                        />
                      </TabPane>
                    </TabContent>
                  </div>
                </Col>
              </Row>
            ) : (
              <ClaimMessage memsSuccess={memsSuccess} ucrn={ucrn} draft={draft} />
            )}
          </div>
        </section>
      </>
    </Template>
  );
};

EditClaim.propTypes = {
  defaultData: PropTypes.shape({}).isRequired,
  active: PropTypes.string.isRequired,
  policyData: PropTypes.shape({
    expiryDate: PropTypes.string,
    policyNumber: PropTypes.number,
    certificateNumber: PropTypes.string,
  }).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  bankList: PropTypes.arrayOf(PropTypes.shape({})),
  currencyList: PropTypes.arrayOf(PropTypes.shape({})),
  countryList: PropTypes.arrayOf(PropTypes.shape({})),
  addBankAccount: PropTypes.func.isRequired,
  setActive: PropTypes.func.isRequired,
  onFileSelected: PropTypes.func.isRequired,
  onFileRemoved: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  deleteBank: PropTypes.func.isRequired,
  bankSelected: PropTypes.bool.isRequired,
  btnClick: PropTypes.bool.isRequired,
  success: PropTypes.bool,
  memsSuccess: PropTypes.bool,
  ucrn: PropTypes.string,
  draft: PropTypes.bool,
  // message: PropTypes.string,
  mandatoryFilesUploaded: PropTypes.shape({}).isRequired,
  bankDeleteLoading: PropTypes.bool,
};

EditClaim.defaultProps = {
  bankList: [],
  currencyList: [],
  countryList: [],
  loading: false,
  success: false,
  memsSuccess: false,
  ucrn: '',
  draft: false,
  bankDeleteLoading: false,
  // message: '',
};

export default withRouter(EditClaim);
